import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogDrawer from './LogDrawer';
import { InstituteAutomationService, OverviewStats } from '../instituteAutomationService';

export type ModuleTab = 'overview' | 'global' | 'client' | 'preview';

const TABS: { id: Exclude<ModuleTab, 'preview'>; label: string; badge: (s: OverviewStats) => number }[] = [
    { id: 'overview', label: '📊 Overview', badge: (s) => s.reportsScheduled },
    { id: 'global', label: '⚙️ Global Settings', badge: (s) => s.componentCount },
    { id: 'client', label: '🏫 Client Settings', badge: (s) => s.activeOverrides },
];

/** Shared top header + tab nav for every page in the Automated Report Module. */
const ModuleHeader: React.FC<{ active: ModuleTab }> = ({ active }) => {
    const navigate = useNavigate();
    const [logOpen, setLogOpen] = useState(false);
    const [stats, setStats] = useState<OverviewStats | null>(null);

    useEffect(() => {
        let cancelled = false;
        InstituteAutomationService.getOverviewStats().then((s) => { if (!cancelled) setStats(s); }).catch(() => {});
        return () => { cancelled = true; };
    }, []);

    const go = (tab: string) => navigate(`/institute-automation-report-dashboard?tab=${tab}`);

    return (
        <>
            <div className="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-4">
                <h3 className="mb-0 font-20 font-600 text-dark-blue" style={{ cursor: 'pointer' }} onClick={() => go('overview')}>Automated Report Module</h3>
                <div className="d-flex gap-2 mt-2 mt-md-0">
                    <button className="btn btn-sm btn-outline-secondary font-13 font-500 d-flex align-items-center gap-1 py-2 px-3" onClick={() => setLogOpen(true)}>📋 View Log</button>
                </div>
            </div>

            <nav className="nav nav-tabs border-bottom mb-4" role="tablist">
                {TABS.map((t) => {
                    const isActive = active === t.id;
                    const num = stats ? t.badge(stats) : null;
                    return (
                        <button key={t.id}
                            className={`nav-link font-13 font-500 border-0 px-3 py-2 bg-transparent ${isActive ? 'active text-dark border-bottom border-warning' : 'text-secondary'}`}
                            onClick={() => go(t.id)}>
                            {t.label}
                            {num != null && <span className={`badge rounded-pill font-10 ms-1 px-2 py-0.5 ${isActive ? 'bg-warning bg-opacity-10 text-warning-emphasis' : 'bg-light text-secondary'}`}>{num}</span>}
                        </button>
                    );
                })}
                {active === 'preview' && (
                    <span className="nav-link font-13 font-500 border-0 px-3 py-2 active text-dark border-bottom border-warning">👁️ Preview &amp; Send</span>
                )}
            </nav>

            <LogDrawer open={logOpen} onClose={() => setLogOpen(false)} />
        </>
    );
};

export default ModuleHeader;
